import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import newOffers from './offers'
import discovery from './discovery'
import profile from './profile'
import offersDestinations from './offersDestinations'
import bookingSummary from './bookingSummary'
import manageMembers from './manageMembers'

export { state, mutations, getters, actions }

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    newOffers,
    profile,
    offersDestinations,
    discovery,
    bookingSummary,
    manageMembers
  },
  state,
  mutations,
  getters,
  actions
})
